import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { OrbitalsLoaderComponent } from './orbitalsloader.component'

@NgModule({
    imports: [CommonModule],
    declarations: [OrbitalsLoaderComponent],
    exports: [OrbitalsLoaderComponent],
})
export class OrbitalsLoaderModule {}
